import nj from "numjs"
import npyjs from "./npyjs"

const npy = new npyjs()

if (typeof gradientsCache === "undefined") {
  window.gradientsCache = {}
}

export default async (modelName, layer1, layer2) => {
  const key = `${modelName}_${layer1}_${layer2}`

  if (gradientsCache[key]) {
    return await gradientsCache[key]
  }

  const file = `https://storage.googleapis.com/fls/nickc/circuit_gradients/${key}.npy`

  gradientsCache[key] = new Promise(resolve => {
    npy.load(file, ({ data, shape }) => {
      const reshaped = nj
        .array(data, "int8")
        .reshape(shape)
        .transpose(2, 3, 0, 1)
      resolve(reshaped.tolist())
    })
  })

  return gradientsCache[key]
}
